module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Banner'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wiki row kit-contrast-hidden-tb kit-hidden-mb pad"
  }, [_c('section', {
    staticClass: "col-tb-12"
  }, [_c('Navigation', {
    staticClass: "navigation",
    attrs: {
      "payload": _vm.items,
      "device": "pad"
    }
  }), _vm._v(" "), _c('Items', {
    staticClass: "items",
    attrs: {
      "payload": _vm.items,
      "device": "pad"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wiki row kit-hidden-tb"
  }, [_c('section', {
    staticClass: "col-tb-3 "
  }, [_c('Navigation', {
    attrs: {
      "payload": _vm.items,
      "device": "pc"
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "col-tb-9 kit-hidden-tb"
  }, [_c('Items', {
    attrs: {
      "payload": _vm.items,
      "device": "pc"
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wiki row kit-contrast-hidden-mb kit-max-mb"
  }, [_c('section', {
    staticClass: "col-tb-12"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f5e9e140!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Mvvm.vue
// module id = 431
// module chunks = 2